import cookies from 'react-cookies';
import i18n from 'i18next';
import {
    USER_COURSES_INFO_CHANGED,
    USER_COURSES_OPERATION_START,
    USER_COURSES_OPERATION_FINISH,
    USER_COURSES_OPERATION_FAIL,
    USER_GET_ALL_COURSES,
    USER_GET_ALL_COURSES_PROGRESS,
    USER_SELECT_COURSE,
    USER_GET_COURSE_STRUCT,
    USER_GET_COURSE_EXAMS,
    USER_GET_COURSE_STRUCT_START,
    USER_GET_COURSE_STRUCT_FAIL,
    USER_GET_COURSE_STRUCT_FINISH,
    USER_CLEAR_COURSES_DATA,
} from '../types';

import request from '../../api';

let allCoursesRequest = null;
let courseStructRequestId = 0;

export const userCoursesInfoChange = ({ props, value }) => {
    return { type: USER_COURSES_INFO_CHANGED, payload: { props, value } };
};

export const userGetAllCourses = () => async dispatch => {
    // Authentication bootstrap and the dashboard can mount in the same render.
    // Share their request so both callers receive the same result without
    // downloading the course list more than once.
    if (allCoursesRequest) return allCoursesRequest;

    dispatch({ type: USER_COURSES_OPERATION_START });
    allCoursesRequest = (async () => {
        try {
            const { data: { data } } = await request.get('/student/courses/subscribed');
            dispatch({ type: USER_GET_ALL_COURSES, payload: data });

            // Course cards must not wait for this expensive calculation. The
            // list is rendered first, then progress is merged into Redux when
            // the background request completes. The backend pool has enough
            // connections for this query not to block book navigation.
            const coursesIds = data.map(course => course.id).join(',');
            if (coursesIds) {
                request.get('/student/performance/courses', { params: { coursesIds } })
                    .then(({ data: progress }) => dispatch({
                        type: USER_GET_ALL_COURSES_PROGRESS,
                        payload: progress.data,
                    }))
                    .catch(() => undefined);
            }
            return data;
        } catch (err) {
            if (err.response) dispatch({ type: USER_COURSES_OPERATION_FAIL, payload: { props: 'body', value: i18n.t('ErrorBody') } });
            else dispatch({ type: USER_COURSES_OPERATION_FAIL, payload: { props: 'conn', value: i18n.t('ErrorConn') } });
        } finally {
            dispatch({ type: USER_COURSES_OPERATION_FINISH });
            allCoursesRequest = null;
        }
    })();

    return allCoursesRequest;
};

export const userSelectCourse = (course) => {
    const selectedCourseCookie = cookies.load('coursePref');
    if (selectedCourseCookie) cookies.remove('coursePref');
    cookies.save('coursePref', course.id, {
        path: '/',
        expires: new Date().setDate(Date.now() + 1000 * 60 * 60 * 24 * 14),
        maxAge: 60 * 60 * 24 * 365
    });
    return { type: USER_SELECT_COURSE, payload: course };
};

export const userGetSelectedCourseStruct = (courseId, withoutLoad) => async dispatch => {
    // Track background refreshes too: a late course/tab request must not
    // replace the selected course's data, errors or loading state.
    const meta = { courseId, requestId: ++courseStructRequestId, withoutLoad: Boolean(withoutLoad) };
    dispatch({ type: USER_GET_COURSE_STRUCT_START, meta });
    try {
        const promise1 = request.get(`/student/course/${courseId}/content`);
        const promise2 = request.get(`/student/exams/subscribed/course/${courseId}?mustParentChild=true`)
            .then(response => {
                // Course action cards only need the allowed exams. Publish them
                // without waiting for units, topics, resources and progress.
                dispatch({ type: USER_GET_COURSE_EXAMS, payload: response.data.data, meta });
                return response;
            });
        const data = await Promise.all([promise1, promise2]);
        const courseStruct = data[0].data.data;
        // The course's downloadable files, sent beside the structure and only
        // when the subscription's package carries the EDU_RESOURCE feature.
        const resources = data[0].data.resources ?? [];
        const allowedExams = data[1].data.data;
        dispatch({ type: USER_GET_COURSE_STRUCT, payload: { courseStruct, allowedExams, resources }, meta });
    } catch (err) {
        if (err.response) dispatch({ type: USER_GET_COURSE_STRUCT_FAIL, payload: { props: 'body', value: i18n.t('ErrorBody') }, meta });
        else dispatch({ type: USER_GET_COURSE_STRUCT_FAIL, payload: { props: 'conn', value: i18n.t('ErrorConn') }, meta });
    } finally {
        dispatch({ type: USER_GET_COURSE_STRUCT_FINISH, meta });
    }
};

export const userClearCoursesData = () => {
    return { type: USER_CLEAR_COURSES_DATA };
};



